import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import {
  PeriodicityOfContributionHttpRepository,
  PeriodicityOfContributionDummyRepository,
} from './infrastructure/repository';

// Application
import { SearchPeriodicityOfContributionsQuery } from './application/queries';

// Domain
import { PeriodicityOfContributionRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupPeriodicityOfContribution(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<PeriodicityOfContributionRepository>(
      TYPES.CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_REPOSITORY,
    )
    .to(
      withDummies
        ? PeriodicityOfContributionDummyRepository
        : PeriodicityOfContributionHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchPeriodicityOfContributionsQuery>(
      TYPES.SEARCH_CATALOG_ALLIANZ_PERIODICITY_OF_CONTRIBUTION_QUERY,
    )
    .to(SearchPeriodicityOfContributionsQuery)
    .inSingletonScope();
}
